import { helper as buildHelper } from "@ember/component/helper"
import { htmlSafe } from "@ember/template"

var reader = new commonmark.Parser()
var writer = new commonmark.HtmlRenderer()

export function convert(params /*, hash*/) {
  let regex = /\<link\s"([a-zA-Z\d]*)"\>(.*)\<\/link\>/g

  var text = params[0] || ""

  text = text.replace(regex, (_match, linkId, linkText) => {
    return `<a href="/help/${linkId}">${linkText}</a>`
  })

  var parsed = reader.parse(text)
  var rendered = writer.render(parsed)

  return htmlSafe(rendered)
}

export default buildHelper(convert)
